import { Component, OnDestroy, OnInit, ViewChild, TemplateRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ApiServiceProject } from 'src/app/web/apis/ApiServiceProject';
import { FormGroup, FormBuilder} from '@angular/forms';
import { NgbModalConfig, NgbModal, ModalDismissReasons, NgbCalendar, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { listProjectStage } from 'src/app/web/interfaces/project/stages/create/listProjectStage';
import { ErrorService } from 'src/app/shared/services/errors.service';

class listindicators{
  projects_id:number
  indicators_id:number
  assigned_id:number
  value:number
}
class listasigned{
  id:number
  username:number
}
class state{
  id:number
  name:string
}
@Component({
  selector: 'app-indicators',
  templateUrl: './indicators.component.html',
  styleUrls: ['./indicators.component.scss']
})
export class IndicatorsComponent implements OnInit {
  @Input() idleader=0;

  @ViewChild('defaultTabButtons')
  public defaultTabButtonsTpl: TemplateRef<any>;
  closeResult = ''
  model2: string
  listasigned:listasigned[]
  listStado:[state]
  listIndicators:[state]
  listProjectStage: listProjectStage[] = [];
  dependenceForm: FormGroup;
  leaderid
  type: string;
  edit: boolean;
  create: boolean;
  itemName: string;
  projectId: number;
  selectedDependence
  probabilityName = 0;
  listAssigned: []
  array:listindicators[]

  constructor(
    private spinner: NgxSpinnerService,
    private config: NgbModalConfig,
    private modalService: NgbModal,
    private apiService: ApiServiceProject,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private ngbCalendar: NgbCalendar,
    private dateAdapter: NgbDateAdapter<string>,
    private errorService:ErrorService

  ) {


  //  this.apiService
  //     .getService('list-project-assigned-project?id_project=' + this.projectId)
  //     .subscribe({
  //       next: (rs: any) => {
  //         if (rs.code == null) {
  //           if (rs == '' || rs == null) {
   
  //             Swal.fire({
  //               title: 'No se encontraron registros',
  //               text: '',
  //               icon: 'info',
  //               confirmButtonText: 'Aceptar',
  //               heightAuto: false
  //             }).then((res) => {
  //               if (res.isConfirmed || res.isDismissed) {
  //                 this.router.navigate(['home']);
  //               }
  //             });
  //           }
  //           this.listasigned = rs.listAssigned;

  //         } else {
  //           this.spinner.hide();
  //           Swal.fire({
  //           title:  rs.error,
  //           text: '',
  //           icon: 'error',
  //           heightAuto: false
  //           });
  //         }
  //       },
  //       error: (error) => {
  //         this.errorService.error(error);
  //       },
  //     });
  }

  infoService(){
    this.spinner.show();
    this.activatedRoute.params.subscribe(params => {
      return this.projectId = params['id'];
    })
    this.apiService
    .getService('list-project-view-indicators')
    .subscribe({
      next: (rs: any) => {
        if (rs) {
          this.spinner.hide();
          this.listStado = rs.listStado
          this.listIndicators = rs.listIndicators
          
        } else {
          this.spinner.hide();
          Swal.fire({
          title:  rs.error,
          text: '',
          icon: 'error',
          heightAuto: false
          });
        }
      },
      error: (error) => {
        this.errorService.error(error);
      },
    });
  }


  formSubmit(): void {
    if(this.dependenceForm.value.semana == null || this.dependenceForm.value.semana == undefined ){
      this.dependenceForm.value.semana = 0
    }
    if (this.dependenceForm.value.e1 === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe rellenar todos los campos' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
  if (this.dependenceForm.value.e2 === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe rellenar todos los campos' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
  if (this.dependenceForm.value.e3 === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe rellenar todos los campos' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
  if (this.dependenceForm.value.userid === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe rellenar todos los campos' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    this.spinner.show();
    let obj={
        indicators_id:1,
        projects_id:Number(this.projectId),
        assigned_id:Number(this.idleader),
        value:Number(this.dependenceForm.value.e1)
      }
    let obj2={
        indicators_id:2,
        projects_id:Number(this.projectId),
        assigned_id:Number(this.idleader),
        value:Number(this.dependenceForm.value.e2)
      }
    let obj3={
        indicators_id:3,
        projects_id:Number(this.projectId),
        assigned_id:Number(this.idleader),
        value:Number(this.dependenceForm.value.e3)
      }
    this.array=[obj,obj2,obj3]
    let type
    if(this.dependenceForm.value.semana == true){type = 0}
    if(this.dependenceForm.value.semana == false){type = 1}
    let post={type:type,
              listIndicators:this.array}
    this.apiService
        .postService('project-view-indicator-create', post)
        .subscribe({
          next: (rs: any) => {
            if(rs.code == 0){
              this.spinner.hide();
              Swal.fire({title:rs.message ,text: '',icon: 'success',heightAuto: false}).then((dato)=>{
                this.modalService.dismissAll()
                window.location.reload()
              });
            }
            else if(rs.code == 1){
              this.spinner.hide();
              Swal.fire({title:rs.message ,text: '',icon: 'error',heightAuto: false}).then((dato)=>{
              });
            }
            else{
              this.spinner.hide();
              if(rs.error){Swal.fire({title: rs.error  ,text: '',icon: 'error',heightAuto: false});}
              else Swal.fire({title:rs.error,text: '',icon: 'error',heightAuto: false});
            }
          },
          error: (error) => {
            this.errorService.error(error);
          },
        });
  }

  ngOnInit(): void {
   this.dependenceForm = this.fb.group(
      { e1:[''],
        e2:[''],
        e3:[''],
        semana:['']
    }
    );
  }

  
  public open(
    asd: any,
  ) { 
    this.infoService();
     this.modalService.open(this.defaultTabButtonsTpl, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      this.clearForm()
    })
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  

  validField(field, form) {
    return form.controls[field].errors
      && form.controls[field].touched;
  }

  clearForm() {
   this.dependenceForm.reset()
   
   this.dependenceForm = this.fb.group(
      { e1:[''],
        e2:[''],
        e3:[''],
        semana:['']
    }
    );
  }



}

